import React, { FC, useCallback, useRef, useState } from "react";
import { ActionButton } from "@fluentui/react";
import { css, themeUtils, useTheme } from "cayo.ui";
import { IContextPanel } from "@cayo/shared/api/types/schema";
import { getMenuButtonStyles } from "@cayo/shared/components/Alerts/Alerts.styles";
import { useContextPanel } from "@cayo/shared/hooks/useContextPanel";
import logger from "@cayo/shared/libs/logger";

const ContextPanel: FC<IContextPanel> = (props) => {
  const theme = useTheme();

  const [isSelected, setSelected] = useState(false);
  const buttonRef = useRef(null);

  const { showСontextPanel, hideContextPanel } = useContextPanel();

  const getTopOffset = () => {
    const div = buttonRef.current! as HTMLDivElement;
    logger.debug(div!.clientHeight);
    return div!.clientHeight;
  };

  const onClose = useCallback(() => {
    hideContextPanel();
  }, []);

  const onButtonClick = useCallback(() => {
    if (isSelected) {
      hideContextPanel();
      return;
    }

    setSelected(true);
    showСontextPanel({
      ...props,
      onClose,
      onClosed: () => setSelected(false),
      panelType: "smallFixedFar",
      style: { marginTop: getTopOffset() },
      type: "panel",
    });
  }, [isSelected]);

  return (
    <>
      <div ref={buttonRef} className={css.h100p}>
        <ActionButton
          id={props.name}
          ariaLabel={props.name}
          text=""
          onClick={onButtonClick}
          styles={getMenuButtonStyles(isSelected, theme)}
          iconProps={themeUtils.getIconProps(props.icon)}
        />
      </div>
    </>
  );
};

export default ContextPanel;
